import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "create-form" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "form-wrap pt-0" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-sm-6" }, [
    /*#__PURE__*/_createVNode("div", null, [
      /*#__PURE__*/_createVNode("h1", { class: "title" }, "send mail notification"),
      /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "Notifiy user.")
    ])
  ])
], -1)
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "" }, "Subject", -1)
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createVNode("label", { for: "" }, "Select Template", -1)
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "" }, "Mail", -1)
const _hoisted_11 = { class: "text-right" }
const _hoisted_12 = { class: "modal-wrap default-modal" }
const _hoisted_13 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "sendMail",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_14 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_15 = { class: "modal-content" }
const _hoisted_16 = { class: "modal-header" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "d-block" }, [
  /*#__PURE__*/_createVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, "Select Mail"),
  /*#__PURE__*/_createVNode("p", { class: "text-muted" }, "Select Send Mail Email")
], -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_19 = { class: "modal-body" }
const _hoisted_20 = { class: "card" }
const _hoisted_21 = { class: "filter-wrap" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-5 col-6" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", null, "Search", -1)
const _hoisted_26 = { class: "col-md-3 col-6" }
const _hoisted_27 = { class: "mt-1" }
const _hoisted_28 = { class: "card p-0" }
const _hoisted_29 = { class: "table-responsive" }
const _hoisted_30 = { class: "table table-shadowed table-relative mb-0" }
const _hoisted_31 = { class: "table-primary" }
const _hoisted_32 = { scope: "col" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Name ")
const _hoisted_34 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Email", -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "mb-0" }
const _hoisted_37 = { class: "user-img-wrap" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { colspan: "5" }
const _hoisted_40 = {
  key: 2,
  class: "table-loader chat-load"
}
const _hoisted_41 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_editor = _resolveComponent("editor")
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_ErrorList, {
            errors: _ctx.state.ui.error.validationList,
            hasError: _ctx.state.ui.error.hasError
          }, null, 8, ["errors", "hasError"]),
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createVNode("input", {
              id: "titleOfForm",
              type: "text",
              class: "form-control",
              placeholder: "Purpose of Creating the Mail",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.subject = $event))
            }, null, 512), [
              [_vModelText, _ctx.state.subject]
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createVNode("select", {
              class: "custom-select form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.filter.selected = $event)),
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.selectedTemplate && _ctx.selectedTemplate(...args)))
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.templateList, (template, templateIndex) => {
                return (_openBlock(), _createBlock("option", {
                  value: template.mail_template,
                  key: templateIndex
                }, _toDisplayString(template.title), 9, ["value"]))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.state.filter.selected]
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_editor, {
              modelValue: _ctx.state.message,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.message = $event)),
              "api-key": "0mtfvz9o2d1dtxzrihma4kfs89lyd6hrg4wjexajn0j5f0ia",
              init: {
            selector: 'textarea.tinymce',
            theme: 'silver',
            height: 600,
            plugins: [
              'advlist', 'autolink', 'link', 'image', 'lists', 'charmap', 'preview', 'anchor', 'pagebreak',
              'searchreplace', 'wordcount', 'visualblocks', 'visualchars', 'code', 'fullscreen', 'insertdatetime',
              'media', 'table', 'emoticons', 'help'
            ],
            toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table mergetags| image | addcomment showcomments | spellcheckdialog a11ycheck typography | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat | code',
            image_advtab: true,
            images_file_types: 'jpg,svg,webp',


          }
            }, null, 8, ["modelValue", "init"])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("a", {
              class: "btn default-btn",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showSendMail && _ctx.showSendMail(...args)))
            }, "Continue")
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hideSendMail && _ctx.hideSendMail(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_18
              ])
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errorList,
                hasError: _ctx.state.ui.hasErrorStatus
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", _hoisted_22, [
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.email = $event)),
                          class: "form-control"
                        }, null, 512), [
                          [_vModelText, _ctx.state.email]
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_26, [
                      _createVNode("div", _hoisted_27, [
                        _createVNode("a", {
                          class: "btn default-btn w-100 mt-4",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clearSearch()))
                        }, "Clear")
                      ])
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_28, [
                _createVNode("div", _hoisted_29, [
                  _createVNode("table", _hoisted_30, [
                    _createVNode("thead", _hoisted_31, [
                      _createVNode("tr", null, [
                        _createVNode("th", _hoisted_32, [
                          _withDirectives(_createVNode("input", {
                            class: "mr-2",
                            type: "checkbox",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.checkAll())),
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.isCheckedAll = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.state.isCheckedAll]
                          ]),
                          _hoisted_33
                        ]),
                        _hoisted_34
                      ])
                    ]),
                    (_ctx.state.userList.length)
                      ? (_openBlock(), _createBlock("tbody", _hoisted_35, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.userList, (user, userIndex) => {
                            return (_openBlock(), _createBlock("tr", { key: userIndex }, [
                              _createVNode("td", null, [
                                _createVNode("p", _hoisted_36, [
                                  _withDirectives(_createVNode("input", {
                                    class: "mr-2",
                                    type: "checkbox",
                                    value: user.id,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.checkUser = $event)),
                                    onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.updateCheckall && _ctx.updateCheckall(...args)))
                                  }, null, 40, ["value"]), [
                                    [_vModelCheckbox, _ctx.state.checkUser]
                                  ]),
                                  _createVNode("span", _hoisted_37, [
                                    (user.image)
                                      ? (_openBlock(), _createBlock("img", {
                                          key: 0,
                                          src: user.image,
                                          alt: ""
                                        }, null, 8, ["src"]))
                                      : (_openBlock(), _createBlock("img", {
                                          key: 1,
                                          src: user.imageBaseUrl
            ? `${user.imageBaseUrl}img/avatar-1.jpg`
            : 'img/avatar-1.jpg'
            ,
                                          alt: ""
                                        }, null, 8, ["src"]))
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(user.full_name), 1)
                                ])
                              ]),
                              _createVNode("td", null, _toDisplayString(user.email), 1)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createBlock("tfoot", _hoisted_38, [
                          _createVNode("tr", null, [
                            _createVNode("td", _hoisted_39, [
                              _createVNode(_component_EmptyData, {
                                title: _ctx.state.data.title,
                                heading: _ctx.state.data.heading
                              }, null, 8, ["title", "heading"])
                            ])
                          ])
                        ])),
                    (_ctx.state.ui.isPostLoading.getUserActivityList)
                      ? (_openBlock(), _createBlock("div", _hoisted_40, [
                          _createVNode("img", {
                            src: _ctx.state.data.imageBaseUrl
            ? `${_ctx.state.data.imageBaseUrl}img/chat-loading.gif`
            : 'img/chat-loading.gif'
            ,
                            alt: ""
                          }, null, 8, ["src"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_41, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.sendMail && _ctx.sendMail(...args)))
              }, " Send ")
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.SuccessFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ]))
}